import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "courseTitle", "authorName", "courseDescription",
                     "sectionsCount", "acceptForm", "declineForm"]

  open(event) {
    const { courseTitle, authorName, courseDescription, sectionsCount, acceptUrl, declineUrl } = event.params

    this.courseTitleTarget.textContent = courseTitle || ""
    this.authorNameTarget.textContent = authorName || ""
    this.courseDescriptionTarget.textContent = courseDescription || ""

    if (sectionsCount && parseInt(sectionsCount) > 0) {
      this.sectionsCountTarget.textContent = `${sectionsCount} sections`
      this.sectionsCountTarget.classList.remove("hidden")
    } else {
      this.sectionsCountTarget.classList.add("hidden")
    }

    this.acceptFormTarget.action = acceptUrl
    this.declineFormTarget.action = declineUrl

    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      this.close()
    }
  }
}
